module.exports = __webpack_public_path__ + "media/images/flags/VN-cd54ef4a68c34ab33aed50c250bbbcb3.svg";